import tuner from '../tuner';
import streamProcessor from '../streamProcessor';

export default function processTransitionStream(stream = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      tuner.streamPlayer.on(tuner.streamPlayer.events.mediaEnded, resolve);
      await streamProcessor.processTransitionStream(stream);
    } catch (transitionStreamError) {
      reject(transitionStreamError);
    }
  });
}
